module.exports = __webpack_public_path__ + "static/20200804_154734-496564767d65bdfb6228d51b0d903729.jpg";